import { styled } from '@mui/material/styles';
import { AnimatedImage } from 'core/common/ui/widgets/AnimatedImage';

export const AnimatedImageStyled = styled(AnimatedImage)<{ $widthPx: number; $heightPx: number }>`
  flex-shrink: 0;
  width: ${({ $widthPx }) => `${$widthPx}px`};
  height: ${({ $heightPx }) => `${$heightPx}px`};
`;
